import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { ProductionRoutingCompParams } from '@app/services/production-routing.service';

@Component({
    selector: 'tt-production-routing-comp-view',
    templateUrl: './production-routing-comp-view.component.html',
    styleUrls: ['./production-routing-comp-view.component.css'],
})
export class ProductionRoutingCompViewComponent {
    public params: ProductionRoutingCompParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as ProductionRoutingCompParams;
    }

    public onSubmit() {
        this.state.back();
    }
}
